import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="not-found-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--brunchi-green-hover)] mb-3">404</div>
      <h1 className="font-display text-4xl sm:text-5xl font-bold leading-tight">
        This page took a coffee break.
      </h1>
      <p className="mt-4 text-sm text-[color:var(--brunchi-ink-soft)]">
        The page you're looking for doesn't exist — but the pantry is fully stocked.
      </p>
      <Link
        to="/shop"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full pill-primary font-medium"
        data-testid="not-found-shop-btn"
      >
        Browse the shop
      </Link>
    </div>
  );
}
